import React from 'react';
import styled from 'styled-components';
import { Button } from '@gr-monorepo/common/ui';
import { ReactComponent as MaxIcon } from './max-icon.svg';
import { LogClick } from 'features/shared/ClickStream';
import { OLYMPIADS_MAX_BOT_URL } from '@gr-monorepo/common/public/ui/constants';

export const Plate = styled.div`
  display: flex;
  align-items: center;
  background: rgba(9, 21, 38, 0.07);
  border-radius: 10px;
  padding: 24px 24px;
  justify-content: space-between;

  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.85);
`;

const GradientButton = styled(Button)`
    background: linear-gradient(90deg, #00BFFF 0%, #5B33FF 50%, #9500FF 100%);
`;

const OlympiadsStatisticMiniAppLink = ({ cabmunId: _cabmunId }: { cabmunId: number }) => {
  return (
    <Plate>
      <span>Статистика по олимпиадам всегда под рукой в приложении Учи.ру</span>
      <LogClick
        eventType="olympiads-mini-app-click"
        eventInfo="Клик по ссылке на мини-приложение в Telegram по олимпиадам"
        eventSource="olympiads-page"
      >
        <GradientButton as="a" href={OLYMPIADS_MAX_BOT_URL} style={{ width: 185, flex: '0 0 auto', marginRight: '8px' }} target="_blank">
          <MaxIcon style={{ marginRight: 8 }} /> Перейти
        </GradientButton>
      </LogClick>
    </Plate>
  );
};

export default OlympiadsStatisticMiniAppLink;
